import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {BASE_URL, UserContext} from '../contexts/UserContext'
import axios from "axios"
import ButtonLoader from '../components/ButtonLoader'

const Login = () => {

  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState({
    username: "",
    password: "",
  });


  const {error,setError,setMessage, setCurrentUser, setIsAuthenticated} = useContext(UserContext)
  const navigate = useNavigate()


  const changeInputHandler = (e) => {
    setUserData((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const {data} = await axios.post(`${BASE_URL}/users/login`, userData, {
        headers: {
          "Content-Type": "application/json"
        },
        withCredentials: true
      });
      setCurrentUser(data?.user);
      setMessage(data?.message);
      setError(null);
      setIsAuthenticated(true);
      navigate("/")
    } catch (error) {
      setError(error.response.data.message);
      setMessage(null);
      setIsAuthenticated(false);
    }finally{
      setLoading(false);
    }
  };
  return (
    <section className="register">
      <div className="container">
        <h2>Sign In</h2>
        <form onSubmit={handleLoginSubmit} className="form register__form">
            {
              error && <p className={`form__error-message`}>{error}</p>
            }
          <input
            type="text"
            placeholder="Username"
            name="username"
            value={userData.username}
            onChange={changeInputHandler}
          />
          <input
            type="password"
            placeholder="Password"
            name="password"
            value={userData.password}
            onChange={changeInputHandler}
          />
          <button type="submit" className="btn primary">
            {
              loading ? <ButtonLoader/> : 'Login'
            }
          </button>
        </form>
        <small>
          Don't have any account? <Link to={"/register"}>Sign Up</Link>
        </small>
      </div>
    </section>
  );
};

export default Login;
